/**
 * Make promise handling easier
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this._isResolved = false;
        this._isRejected = false;
        this._promise = new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        /**
         * The promise
         */
        get: function () {
            return this._promise;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Resolve the promise with the specified value
     */
    Deferred.prototype.resolve = function (value) {
        if (this.isCompleted) {
            throw new Error('Already completed');
        }
        this._resolve(value);
    };
    /**
     * Reject the promise with the specified value
     */
    Deferred.prototype.reject = function (value) {
        if (this.isCompleted) {
            throw new Error('Already completed');
        }
        this._reject(value);
    };
    Object.defineProperty(Deferred.prototype, "isResolved", {
        /**
         * Is the promise resolved?
         */
        get: function () {
            return this._isResolved;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Deferred.prototype, "isRejected", {
        /**
         * Is the promise rejected?
         */
        get: function () {
            return this._isRejected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Deferred.prototype, "isCompleted", {
        /**
         * Is the promise resolved or rejected?
         */
        get: function () {
            return this._isResolved || this.isRejected;
        },
        enumerable: true,
        configurable: true
    });
    return Deferred;
}());
export { Deferred };
